import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import Header from './components/header/Header';
import ConsumerLayout from '../consumer-layout/ConsumerLayout';
import PredictResponse from '../../genie/components/predict-response/PredictResponse';
import GenerateMessages from '../../genie/components/generate-messages/GenerateMessages';
import {
  generateConsumerAlternate,
  generateConsumerGenieMessages,
  getConsumerGenieAudiences,
  predictConsumerResponse,
  replyConsumerGenie,
  resetGenieSession,
} from '../../redux/consumer/genie/consumerGenieActions';
import { uploadFile } from '../../redux/scout/scoutActions';
import { resetConsumerData } from '../../redux/consumer/consumerReducer';
import { resetGenieParams } from '../../redux/genie/genieReducer';
import { getGenieBrandOptions } from '../../redux/genie/genieActions';

import scss from './Genie.module.scss';

function Genie() {
  const dispatch = useDispatch();

  const handlePredictResponse = (values) => {
    dispatch(predictConsumerResponse(values));
  };

  const handleGenerateAlternate = (values) => {
    dispatch(generateConsumerAlternate(values));
  };

  useEffect(() => {
    dispatch(getGenieBrandOptions());
    dispatch(getConsumerGenieAudiences());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      dispatch(resetConsumerData());
      dispatch(resetGenieParams());
      dispatch(resetGenieSession());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleResetSession = () => {
      dispatch(resetGenieSession());
    };

    window.addEventListener('beforeunload', handleResetSession);

    return () => {
      window.removeEventListener('beforeunload', handleResetSession);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ConsumerLayout Header={Header()}>
      <div className={scss.pageWrapper}>
        <PredictResponse onPredictResponse={handlePredictResponse} onGenerateAlternate={handleGenerateAlternate} />

        <GenerateMessages
          onGenerateMessages={generateConsumerGenieMessages}
          onReply={replyConsumerGenie}
          onResetSession={resetGenieSession}
          onFileUpload={uploadFile}
        />
      </div>
    </ConsumerLayout>
  );
}

export default Genie;
